import LoadingImg from "../img/loading.svg";
const LoadingScreen = () => {
  return (
    <div className="loadingScreen">
      <img src={LoadingImg} alt="Loading" />
    </div>
  );
};

export default LoadingScreen;
